module.exports = __webpack_public_path__ + "static/img/边框15.b059611.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框15.svg
// module id = 4x1p
// module chunks = 2